export interface IUserDetails {
    id: string;
    username: string;
    role: string
    active: boolean;
}

export const userRolesList: Record<string, string> = {
    "1": "Employee",
    "2" : "Admin" 
}

